import React, { Fragment, useRef, useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Card from '../../../../components/Card/Card';
import Pagination from '../../../../components/Pagination/Pagination';
import PaymentOrdersForm from '../../../../components/Finances/PaymentsOrdersForm/PaymentsOrdersForm';
import PaymentOrdersList from '../../../../components/Finances/PaymentOrdersList';
import TableSettings from '../Offer/TableSettings';
import { LocalStorage } from '../../../../utils/utils';
import Icon from '../../../../components/Icon/Icon';

const PaymentOrders = ({
  data: {
    loading,
    page,
    sessionId,
    error,
    status,
    type,
    currencies,
    balance,
    orders,
    pageCount,
    timeDiff,
    purses,
    rules,
    history,
    isForm,
    wallets,
    transport,
  },
  onSubmit,
  resetFormState,
  onCurrencyChange,
  onPageChange,
}) => {
  const [tableSettings, changeSettings] = useState({});
  const [settingsModalOpen, toggleModal] = useState();

  useEffect(_ => {
    const settings = LocalStorage.get('paymentOrdersTableSettings')
      ? LocalStorage.get('paymentOrdersTableSettings')
      : {
          date: true,
          total: true,
          purse: true,
          status: true,
          icon: true,
        };
    changeSettings(settings);
  }, []);

  const editSettings = settings => {
    LocalStorage.set('paymentOrdersTableSettings', { ...tableSettings, ...settings });
    changeSettings({ ...tableSettings, ...settings });
    toggleModal(!settingsModalOpen);
  };

  const controls = [
    <Button color="primary" size="sm" onClick={() => toggleModal(true)}>
      <Icon type="kma-panel" tag="i" />
    </Button>,
  ];

  const $el = useRef(null);
  return isForm ? (
    <PaymentOrdersForm
      authType={type}
      resetFormState={resetFormState}
      loading={loading}
      purses={purses}
      rules={rules}
      currencies={currencies}
      balance={balance}
      onSubmit={onSubmit}
      onCurrencyChange={onCurrencyChange}
      error={error}
      status={status}
      sessionId={sessionId}
      validTill={timeDiff}
      history={history}
      wallets={wallets}
      transport={transport}
    />
  ) : (
    <Fragment>
      <Card.WithControls controls={controls}>
        {orders.length > 0 ? (
          <div ref={$el}>
            <PaymentOrdersList tableSettings={tableSettings} payments={orders} />
          </div>
        ) : (
          <div ref={$el}>
            <PaymentOrdersList tableSettings={tableSettings} />
          </div>
        )}

        {pageCount > 1 && (
          <Card.Footer>
            <Pagination
              pageCount={pageCount}
              onPageChange={onPageChange}
              activePage={page + 1}
              scrollToAfterPageChanged={{ ref: $el.current }}
            />
          </Card.Footer>
        )}
        <Modal isOpen={settingsModalOpen} toggle={_ => toggleModal(false)}>
          <ModalHeader toggle={_ => toggleModal(false)}>
            <FormattedMessage id="postback.logs.settings" defaultMessage="Customize fields" />
          </ModalHeader>
          <ModalBody>
            <TableSettings settings={tableSettings} editSettings={editSettings} />
          </ModalBody>
        </Modal>
      </Card.WithControls>
    </Fragment>
  );
};

export default PaymentOrders;
